import React, { useEffect, useState } from "react";
import "./mySubscription.css";
import moment from "moment";
import AddCard from "./AddCardForm";

const CardBrandIcon = ({ brand }) => {

  switch (brand) {
    case "visa":
      return (
        <img
          src="https://img.icons8.com/color/48/visa.png"
          alt="Visa"
          className={'inline-icon '}
        />
      );
    case "mastercard":
      return (
        <img
          src="https://img.icons8.com/color/48/mastercard-logo.png"
          alt="Mastercard"
          className={'inline-icon '}
        />
      );
    case "amex":
      return (
        <img
          src="https://img.icons8.com/color/48/amex.png"
          alt="Amex"
          className={'inline-icon '}
        />
      );
    case "discover":
      return (
        <img
          src="https://img.icons8.com/color/48/discover.png"
          alt="Discover"
          className={'inline-icon '}
        />
      );
    case "jcb":
      return (
        <img
          src="https://img.icons8.com/color/48/jcb.png"
          alt="JCB"
          className={'inline-icon '}
        />
      );
    case "diners":
      return (
        <img
          src="https://img.icons8.com/color/48/diners-club.png"
          alt="Diners"
          className={'inline-icon '}
        />
      );
    default:
      return null;
  }
};

export default function MySubscription() {
  const [subscription, setSubscription] = useState(null);
  const [user, setUser] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [cards, setCards] = useState([]);
  const [defaultCard, setDefaultCard] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("vs_UserSession"));
    if (!user) return;
    setUser(user);
    getSubscription(user);
  }, []);

  useEffect(() => {
    if (!subscription?.stripe_subscription_id) return;
    getPaymentHistory(subscription);
  }, [subscription]);

  const getSubscription = async (user) => {
    fetch(`${global.API_STRIPEAPI_URL}mySubscriptions/${user.loginId}`)
      .then((res) => res.json())
      .then((data) => {
        setSubscription(data)
        loadCards(data.stripe_customer_id);
      })
      .catch((err) => console.error("Error fetching subscription:", err));
  };

  const getPaymentHistory = async (subscription) => {
    fetch(
      `${global.API_STRIPEAPI_URL}getInvoicesBySubscription/${subscription.stripe_subscription_id}`
    )
      .then((res) => res.json())
      .then((data) => {
        setPaymentHistory(data); 
      })
      .catch((err) => console.error("Error fetching subscription:", err));
  };

  const loadCards = async (customerId) => {
    const res = await fetch(`${global.API_STRIPEAPI_URL}cards/${customerId}`);
    const data = await res.json();
    console.log("Cards data:", JSON.stringify(data));
    setCards(data.cards);
    setDefaultCard(data.defaultCard);
  };

  const setAsDefault = async (customerId, subscriptionId, paymentMethodId) => {
    await fetch(`${global.API_STRIPEAPI_URL}cards/set-default`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customerId, subscriptionId, paymentMethodId }),
    });
    loadCards(customerId);
  };

  const deleteCard = async (customerId, paymentMethodId) => {
    await fetch(`${global.API_STRIPEAPI_URL}cards/${paymentMethodId}`, { method: "DELETE" });
    loadCards(customerId);
  };

  const toggleAutoRenew = async () => {
    if (!subscription?.stripe_subscription_id) return;

    const endpoint = "autoRenewSubscription";

    const res = await fetch(`${global.API_STRIPEAPI_URL}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        subscriptionId: subscription.stripe_subscription_id,
        status: !subscription.cancel_at_period_end,
        businessId: user?.loginId,
      }),
    });

    const data = await res.json();
    if (data.success) {
      setSubscription((prev) => ({
        ...prev,
        cancel_at_period_end: !prev.cancel_at_period_end,
      }));
    } else {
      alert(data.error || "Error updating subscription");
      if (data.alreadyGone) getSubscription(user);
    }
  };

  const handelCancelSubscription = async () => {
    if (!subscription?.stripe_subscription_id) return;

    const confirmCancel = window.confirm(
      "Are you sure you want to cancel your subscription? This action is permanent cancelation."
    );

    if (!confirmCancel) return; // Stop if user clicked "Cancel"

    const endpoint = "cancelSubscription";

    try {
      const res = await fetch(`${global.API_STRIPEAPI_URL}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subscriptionId: subscription.stripe_subscription_id,
          businessId: user?.loginId,
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert(data.message || "Your subscription has been canceled.");
        getSubscription(user);
        let _userSession = localStorage.getItem("vs_UserSession");
        if (_userSession != undefined || _userSession != null) {
          _userSession = JSON.parse(_userSession);
          _userSession.subscriptionStatus = "canceled";
          _userSession.subscriptionEndDate = 0;
          localStorage.setItem("vs_UserSession", JSON.stringify(_userSession));
        }
      } else {
        alert(data.error || "Error canceling subscription");
      }
    } catch (error) {
      console.error("Cancel subscription error:", error);
      alert("Something went wrong while canceling your subscription.");
    }
  };

  if (!subscription) return <div className="subscription-page">
    <div className="no-subscription">
          <p>
            Loading subscription...
          </p>
        </div>
  </div>;

  return (
    <div className="subscription-page">
      {subscription?.plan_name ? (
        <div className="subscription-container">
          <div>
            {/* Left Side - Subscription Info */}
            <div className="subscription-box">
              <h2>My Subscription</h2>
              <p>
                <strong>Plan:</strong> {subscription.plan_name}
              </p>
              <p>
                <strong>Price:</strong> {Number(subscription.amount).toFixed(2)}{" "}
                {subscription.currency?.toUpperCase()} /{" "}
                {subscription.interval_type.charAt(0).toUpperCase() +
                  subscription.interval_type.slice(1)}
              </p>
              <p>
                <strong>Start Date:</strong>{" "}
                {moment(subscription.current_period_start * 1000).format(
                  "DD MMM YYYY hh:mm A"
                )}
              </p>
              <p>
                <strong>Expires Date:</strong>{" "}
                {moment(subscription.current_period_end * 1000).format(
                  "DD MMM YYYY hh:mm A"
                )}
              </p>

              <div className="auto-renew">
                <span>Auto-Renew</span>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={!subscription.cancel_at_period_end}
                    onChange={toggleAutoRenew}
                  />
                  <span className="slider round"></span>
                </label>
              </div>

              <button className="cancel-btn" onClick={handelCancelSubscription}>
                Cancel Subscription
              </button>
            </div>
            {/* Cards Section */}
            <div className="cards-section">
              <div className="payment-info-card">
                {cards.map((card) => (
                  <div key={card.id} className="payment-box">
                    <div>
                      {/* {card.card.brand.toUpperCase()} */}
                      <p>
                        {" "}
                        <CardBrandIcon brand={card.card.brand} /> ••••{" "}
                        {card.card.last4}
                      </p>
                      <p className="text-sm">
                        Expires {card.card.exp_month}/{card.card.exp_year}
                      </p>
                      <p className="text-sm">
                        {card.card.funding.charAt(0).toUpperCase() +
                          card.card.funding.slice(1)}{" "}
                        Card
                      </p>
                      <div>
                        {defaultCard !== card.id && (
                          <button
                            onClick={() =>
                              setAsDefault(
                                card.customer,
                                subscription.stripe_subscription_id,
                                card.id
                              )
                            }
                            className="set-default"
                          >
                            Set Default
                          </button>
                        )}
                        {defaultCard !== card.id && (
                          <button
                            onClick={() =>
                              deleteCard(
                                card.customer,
                                card.id
                              )
                            }
                            className="delete-btn"
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="flex gap-2">
                      {defaultCard === card.id && <span>Default</span>}
                    </div>
                  </div>
                ))}
              </div>
              {/* Add Card Box */}
              <div className="add-card-box">
                <AddCard
                  customerId={subscription.stripe_customer_id}
                  onCardAdded={() => {
                    loadCards(subscription.stripe_customer_id);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Right Side - Payment History */}
          <div className="payment-history">
            <h2>Payment History</h2>
            <table className="history-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Invoice</th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory?.length > 0 ? (
                  paymentHistory.map((p, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{moment(p.date).format("DD MMM YYYY")}</td>
                      <td>
                        {p.amount} {p.currency}
                      </td>
                      <td>
                        <span
                          className={
                            p.status === "paid"
                              ? "status-paid"
                              : p.status === "draft"
                              ? "status-draft"
                              : "status-failed"
                          }
                        >
                          {p.status.charAt(0).toUpperCase() + p.status.slice(1)}
                        </span>
                        
                      </td>
                      <td>
                        {p.hosted_invoice_url ? (
                          <a
                            href={p.hosted_invoice_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Invoice
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No payment history available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="no-subscription">
          <p>
            You don’t have an active subscription.{" "}
            <a href="/business/choosePlan">
              Click here to choose a plan
            </a>
            .
          </p>
        </div>
      )}
    </div>
  );
}
